import { render, staticRenderFns } from "./UnidadAcademicaPage.vue?vue&type=template&id=a4da38fe"
import script from "./UnidadAcademicaPage.js?vue&type=script&lang=js&external"
export * from "./UnidadAcademicaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports